import React from 'react';

import {AppButton} from '@/components/Button';
import {PENDING_RETURN_ACTION_IDS} from '@/consts/pendingReturnActionIds';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import usePendingReturnActionRedirect from '@/hooks/usePendingReturnActionRedirect';
import type {ButtonModel} from '@/types/aem';
import {twx} from '@/utils/tailwindUtils';

interface AutoDeliveryDcxSectionButtonProps {
    button?: ButtonModel;
    disabled?: boolean;
}

const AutoDeliveryDcxSectionButton = ({button, disabled}: AutoDeliveryDcxSectionButtonProps) => {
    const isDesktopLayout = useIsDesktopLayout();
    const {redirectToExternalLink} = useConfigExternalLink({...button?.externalLink});
    const onClick = usePendingReturnActionRedirect(
        PENDING_RETURN_ACTION_IDS.AUTO_DELIVERY_DETAILS_EXTENDED,
        redirectToExternalLink
    );

    if (!redirectToExternalLink) return null;

    return (
        <AppButton
            className={twx(
                'shrink-0 border-primary-dark-85 text-14 font-bold leading-[20px] md:font-normal ml:p-0 ml:leading-[24px] ml:text-primary',
                disabled && 'text-primary-dark-65'
            )}
            onClick={onClick}
            tertiary={isDesktopLayout}
            raw={!isDesktopLayout}
            aria-label={button?.alt}
            disabled={disabled}
        >
            {button?.text}
        </AppButton>
    );
};

export default AutoDeliveryDcxSectionButton;
